import {
    AppBar,
    Box,
    Container,
    Divider,
    IconButton,
    Menu,
    Stack,
    Toolbar,
    Typography,
} from "@mui/material"
import MenuIcon from "@mui/icons-material/Menu"

export const FakeHeader = () => {
    return (
        <AppBar
            position="static"
            color="transparent"
            elevation={0}
            sx={{ backgroundColor: "#A0CDB2" }}
        >
            <Container sx={{ height: { xs: "100px", md: "120px" } }}>
                
            </Container>
            <Divider />
        </AppBar>
    )
}
